<template>
  <div class="container-fluid">
    <!--<div class="row text-center bg-warning">
      <div class="col" />
      <div class="col-auto">
        <h4 class="mb-0 py-3">
          <b>Free access for educators through December 2020!</b>
        </h4>
      </div>
      <div class="col" />
    </div>-->

    <!-- Section 1 -->
    <div class="row">
      <div class="col">
        <div
          id="jumbo"
          class="jumbotron jumbotron-fluid"
          style="background-color: white;"
        >
          <h1 class="text-white">Grants for Educators</h1>
          <h3 class="text-white">
            Search, manage, and easily apply for grants.
          </h3>

          <br />
          <p class="lead">
            <router-link
              class="btn btn-primary btn-lg"
              to="tryforfree"
              role="button"
              >Try For Free Now</router-link
            >
          </p>
          <h3>{{ something }}</h3>
        </div>
      </div>
    </div>
    <div><hr /></div>
    <div style="margin-left:-15px; margin-right:-15px; margin-top:-30px;">
      <div class="p-5 mb-0 text-primary">
        <router-link to="/HowItWorks" class="nav-link">
          <h2>How it Works</h2>
        </router-link>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <img src="@/assets/user2.svg" width="75" height="75" alt="icon" />
        <div class="p-3 mb-0 text-dark">
          <h5>Set Up Your Personal Profile</h5>
        </div>
        <div class="p-3 mb-0 text-secondary">
          Identify education details to find grants specific to your needs and
          qualifications.
        </div>
      </div>
      <div class="col">
        <img src="@/assets/review.svg" width="75" height="75" alt="icon" />
        <div class="p-3 mb-0 text-dark">
          <h5>Review Your Grant Opportunities</h5>
        </div>
        <div class="p-3 mb-0 text-secondary">
          Access a continuously updated list of grants that fit your criteria.
        </div>
      </div>
      <div class="col">
        <img src="@/assets/calendar3.svg" width="75" height="75" alt="icon" />
        <div class="p-3 mb-0 text-dark"><h5>Stay on Track</h5></div>
        <div class="p-3 mb-0 text-secondary">
          Your personalized grant calendar will keep you on track during the
          application process and notifications will alert you if due dates are
          approaching.
        </div>
      </div>
      <div class="col">
        <img src="@/assets/contract.svg" width="75" height="75" alt="icon" />
        <div class="p-3 mb-0 text-dark">
          <h5>Write Your Grant</h5>
        </div>
        <div class="p-3 mb-0 text-secondary">
          Utilize templates to easily complete your grant application. Templates
          are available for question responses, measurable outcomes, budgets,
          letters of support, and thank you letters.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      something: ""
    };
  },
  methods: {
    method() {}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#jumbo {
  background-image: url(../assets/students-laptop.jpg);
  background-repeat: no-repeat;
  background-size: 100% auto;
}
</style>
